export class TimeOverride {
    private static OverrideTime: Date;

    public static setTime(time: number | Date): void {
        if (time instanceof Date) {
            TimeOverride.OverrideTime = time;
        } else {
            TimeOverride.OverrideTime = new Date(time);
        }
    }

    public static now(): Date {
        if (!this.OverrideTime) {
            return new Date(Date.now());
        }
        return new Date(this.OverrideTime.valueOf());
    }

    public static valueOf(): number {
        if (!this.OverrideTime) {
            return Date.now();
        }
        return this.OverrideTime.valueOf();
    }

    public static incrementTime(incrementBy: number = 1): void {
        TimeOverride.setTime(TimeOverride.valueOf() + incrementBy);
    }
}
